import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { errMsg } from "@/lib/api";
import { LogIn } from "lucide-react";
import { toast } from "sonner";

export default function LoginPage() {
  const { user, login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const nav = useNavigate();

  if (user && user !== null && user !== false) return <Navigate to="/" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(email, password);
      toast.success("Giriş başarılı");
      nav("/");
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen grid md:grid-cols-2">
      {/* Left panel */}
      <div className="hidden md:block relative overflow-hidden bg-[#0A0A0A]">
        <div
          className="absolute inset-0 bg-cover bg-center opacity-40"
          style={{ backgroundImage: "url(https://images.pexels.com/photos/34902065/pexels-photo-34902065.jpeg)" }}
        />
        <div className="absolute inset-0 grain" />
        <div className="relative z-10 h-full flex flex-col justify-between p-12 text-white">
          <div className="flex items-center gap-3">
            <img src="/keskin-logo.png" alt="Keskin" className="w-14 h-14 object-contain shrink-0" />
            <div>
              <div className="font-heading font-extrabold text-sm tracking-tight">KESKİNTUR PORTAL</div>
              <div className="text-[10px] uppercase tracking-[0.15em] text-white/60 mt-0.5">Şirket Yönetim Sistemi</div>
            </div>
          </div>

          <div>
            <div className="text-[10px] uppercase tracking-[0.2em] text-white/60 mb-4">Kontrol • Şeffaflık • Verim</div>
            <h1 className="font-heading text-4xl md:text-5xl font-extrabold leading-[1.05] tracking-tight mb-6">
              Filonuzu ve<br/>finansınızı<br/>tek panelden yönetin.
            </h1>
            <p className="text-white/70 text-sm max-w-md">
              Şoför maaşları, tedarikçi ödemeleri, yakıt tüketimi, km analizi, ihale takibi ve
              pazarlama verileri — hepsi tek merkezde.
            </p>
          </div>

          <div className="grid grid-cols-3 gap-6 pt-6 border-t border-white/10">
            {[
              { k: "Modül", v: "12+" },
              { k: "Rol", v: "4" },
              { k: "TL", v: "₺" },
            ].map((x) => (
              <div key={x.k}>
                <div className="num text-2xl font-bold">{x.v}</div>
                <div className="text-[10px] uppercase tracking-widest text-white/50 mt-1">{x.k}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Right form */}
      <div className="flex items-center justify-center p-8 bg-[#FAFAFA]">
        <div className="w-full max-w-md">
          <div className="text-[10px] uppercase tracking-[0.2em] text-neutral-500 mb-3">Oturum Aç</div>
          <h2 className="font-heading text-3xl font-extrabold tracking-tight mb-2">Hoş geldiniz</h2>
          <p className="text-sm text-neutral-600 mb-8">Devam etmek için giriş yapın.</p>

          <form onSubmit={submit} className="space-y-4" data-testid="login-form">
            <div>
              <label className="text-xs font-semibold uppercase tracking-widest text-neutral-600">Email</label>
              <input
                data-testid="login-email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="mt-1.5 w-full px-3 py-2.5 bg-white border border-[#E5E5E5] focus:border-[#0A0A0A] focus:outline-none transition text-sm"
                placeholder="admin@sirket.com"
              />
            </div>
            <div>
              <label className="text-xs font-semibold uppercase tracking-widest text-neutral-600">Şifre</label>
              <input
                data-testid="login-password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="mt-1.5 w-full px-3 py-2.5 bg-white border border-[#E5E5E5] focus:border-[#0A0A0A] focus:outline-none transition text-sm"
                placeholder="••••••••"
              />
            </div>

            <button
              data-testid="login-submit"
              disabled={busy}
              type="submit"
              className="w-full mt-4 bg-[#0A0A0A] text-white py-3 text-xs font-semibold uppercase tracking-[0.15em] hover:bg-[#0020C2] transition-colors duration-200 flex items-center justify-center gap-2 disabled:opacity-50"
            >
              <LogIn className="w-4 h-4" strokeWidth={2} />
              {busy ? "Giriş yapılıyor..." : "Giriş Yap"}
            </button>
          </form>

          <div className="mt-8 pt-6 border-t border-[#E5E5E5] text-xs text-neutral-400">
            Hesabınız yoksa yöneticinizle iletişime geçin.
          </div>
        </div>
      </div>
    </div>
  );
}
